import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTelegramWebApp } from '../utils/telegram';

const ThemeContext = createContext();

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem('darkMode');
      return saved ? JSON.parse(saved) : getTelegramWebApp()?.colorScheme === 'dark';
    } catch {
      console.warn('Некорректное значение darkMode в localStorage, сбрасываю в false');
      return false;
    }
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.documentElement.dataset.polkaTheme = isDarkMode ? 'dark' : 'light';
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  const theme = {
    isDarkMode,
    toggleTheme,
    colors: isDarkMode
      ? {
          primary: '#FFFFFF',
          primaryDark: '#E4E4E4',
          onPrimary: '#101113',
          background: '#101113',
          surface: '#181A1B',
          surfaceHover: '#3a3b3c',
          text: '#e4e6eb',
          textSecondary: '#b0b3b8',
          border: '#101113',
          success: '#4caf50',
          warning: '#ff9800',
          error: '#f44336'
        }
      : {
          primary: '#181A1B',
          primaryDark: '#303234',
          onPrimary: '#FFFFFF',
          background: '#FBFBFB',
          surface: '#FBFBFB',
          surfaceHover: '#f0f2f5',
          text: '#1c1e21',
          textSecondary: '#65676b',
          border: '#FBFBFB',
          success: '#4caf50',
          warning: '#ff9800',
          error: '#f44336'
        }
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};
